export const clamp = (min: number, num: number, max: number): number => Math.max(Math.min(num, max), min);

export const sum = (arr: number[]): number => arr.reduce((a, b) => a + b, 0);

// formats currency like $2,500
export const formatCurrency = (num: number, decimals: number | 'auto' = 0): string => {
  let d: number;
  if (decimals === 'auto') {
    d = num !== Math.floor(num) ? 2 : 0;
  } else {
    d = decimals;
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: d,
    minimumFractionDigits: d,
  }).format(num);
};

// formats number like 2,500
export const formatNumber = (num: number, decimals: number | 'auto' = 0): string => {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: decimals === 'auto' ? 2 : decimals,
    minimumFractionDigits: decimals === 'auto' ? 0 : decimals,
  }).format(num);
};

export const formatKw = (num: number, decimals: number | 'auto' = 0): string => {
  return `${formatNumber(num, decimals)} kW`;
};

export const formatKwh = (num: number, decimals: number | 'auto' = 0): string => {
  return `${formatNumber(num, decimals)} kWh`;
};

/*
 * For backwards compatibility
 * @param num: number of any format, e.g. 1, 2.3, -2
 * returns two digit currency formatted string, e.g. $1, $2.30, -$2
 */
export const autoFormatCurrency = (num: number): string => {
  return formatCurrency(num, 'auto');
};

export const formatQuantity = (num?: number): string => (num ? `quantity: ${num}` : '');
